import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

const whiteList = ['/home', '/recruit', '/help', '/download', '/consult', '/agreement'] // no redirect whitelist

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)

  const isIncludesPath = whiteList.filter(item => to.path.includes(item))
  if (isIncludesPath.length) {
    next()
  } else {
    try {
      await store.dispatch('user/handleCheckWhiteAuth')
      await store.dispatch('user/handleCheckNameAuth')
      next()
    } catch (err) {
      next(`/home`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
